import { render, staticRenderFns } from "./ModalNotifWaskat.vue?vue&type=template&id=891a1a70&lang=pug&"
import script from "./ModalNotifWaskat.vue?vue&type=script&lang=js&"
export * from "./ModalNotifWaskat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports